function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { cloneUserSession } from 'invision-core/src/components/session/authentication.actions';
import { EnvironmentSettingNameSelector } from 'invision-core/src/components/environment/environment.selectors';
import { CurrentBusinessUnitSelector } from 'invision-core/src/components/session/businessunit.selectors';
import { CustomWidgetHostedUrlBaseSelector } from 'invision-core/src/components/customWidget/custom.widget.selectors';
import { STATUSES as CUSTOM_WIDGET_STATUSES } from 'invision-core/src/components/customWidget/custom.widget.constants';
import { CustomWidgetContainer } from 'invision-core/src/components/customWidget/custom.widget.container';
import { isApiEvent as isCustomWidgetApiEvent } from 'invision-core/src/components/customWidget/custom.widget.helpers';
import { UserSecurityContextSelector } from 'invision-core/src/components/session/session.selectors';
import { CustomWidgetHasApiIntegrationSelector, CustomWidgetIsErroredSelector, CustomWidgetIsExpandedSelector, CustomWidgetIsLoadingSelector, CustomWidgetSelector } from '../../../reducers/selectors/custom.widgets.selectors';
import { initCustomWidget, setCustomWidgetHeight, setCustomWidgetIsExpanded, setCustomWidgetStatus } from '../../../reducers/actions/custom.widgets.actions';
import LocaleKeys from '../../../locales/keys';
var WIDGET_ELEMENT_ID_PREFIX = 'landing-page-custom-widget';
var LandingPageCustomWidgetController = /*#__PURE__*/function () {
  function LandingPageCustomWidgetController($ngRedux, $sce, $state, $timeout) {
    _classCallCheck(this, LandingPageCustomWidgetController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      $sce: $sce,
      $state: $state,
      $timeout: $timeout,
      LocaleKeys: LocaleKeys,
      widget: null
    });
  }
  return _createClass(LandingPageCustomWidgetController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          currentBusinessUnit: CurrentBusinessUnitSelector(store),
          currentUserContext: UserSecurityContextSelector(store),
          customWidget: CustomWidgetSelector(_this.widgetData.Id)(store),
          customWidgetHasApiIntegration: CustomWidgetHasApiIntegrationSelector(_this.widgetData.Id)(store),
          customWidgetHostedUrlBase: CustomWidgetHostedUrlBaseSelector(store),
          customWidgetIsErrored: CustomWidgetIsErroredSelector(_this.widgetData.Id)(store),
          customWidgetIsExpanded: CustomWidgetIsExpandedSelector(_this.widgetData.Id)(store),
          customWidgetIsLoading: CustomWidgetIsLoadingSelector(_this.widgetData.Id)(store),
          environmentName: EnvironmentSettingNameSelector(store)
        };
      };
      var controllerActions = {
        cloneUserSession: cloneUserSession,
        initCustomWidget: initCustomWidget,
        setCustomWidgetHeight: setCustomWidgetHeight,
        setCustomWidgetIsExpanded: setCustomWidgetIsExpanded,
        setCustomWidgetStatus: setCustomWidgetStatus
      };
      this.disconnect = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.actions = actions;
        _this.state = state;
      });
      this.actions.initCustomWidget({
        height: this.widgetData.Height,
        id: this.widgetData.Id,
        integrationTypeId: this.widgetData.IntegrationTypeId,
        isExpanded: this.widgetData.Expanded,
        statusId: CUSTOM_WIDGET_STATUSES.processing
      });
      if (this.state.customWidgetHasApiIntegration && this.state.customWidgetIsExpanded) {
        this.$timeout(function () {
          _this.initCustomWidgetWithApiIntegration();
        });
      } else if (!this.state.customWidgetHasApiIntegration) {
        this.iframeUrl = this.$sce.trustAsResourceUrl(this.widgetData.URL.startsWith('http') ? this.widgetData.URL : "https://".concat(this.widgetData.URL));

        // events for when a message is received from the widget
        this.receiveWidgetDataEvent = function (evt) {
          if (!isCustomWidgetApiEvent(evt) && _this.iframeUrl) {
            var urlElement = new URL(_this.iframeUrl);
            if (evt.origin === urlElement.origin) {
              var data = null;
              try {
                data = JSON.parse(evt.data);
              } catch (e) {
                data = evt.data;
              }

              // start parsing data with url as a required to differentiate between listeners
              if (_typeof(data) === 'object' && (data.url === urlElement.href || data.url === _this.widgetData.URL)) {
                if (!isNaN(data.height)) {
                  _this.actions.setCustomWidgetHeight({
                    id: _this.widgetData.Id,
                    height: data.height
                  });
                }
              }
            }
          }
        };

        // listen for messages from the widget
        if (window.addEventListener) {
          window.addEventListener('message', this.receiveWidgetDataEvent, false);
        } else {
          // support for IE8
          window.attachEvent('onmessage', this.receiveWidgetDataEvent);
        }
        this.sendConfiguredWidgetData = JSON.stringify({
          AgentId: this.widgetData.SendAgentId ? this.state.currentUserContext.Id : undefined,
          AgentRole: this.widgetData.SendAgentRole ? this.state.currentUserContext.Roles : undefined
        });
      }
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      if (this.receiveWidgetDataEvent) {
        window.removeEventListener('message', this.receiveWidgetDataEvent, false);
      }
      if (this.widget && this.widget.disconnect) {
        this.widget.disconnect();
      }
      this.disconnect();
    }
  }, {
    key: "handleExpansion",
    value: function handleExpansion() {
      var isExpanded = !this.state.customWidgetIsExpanded;
      this.actions.setCustomWidgetIsExpanded({
        id: this.widgetData.Id,
        isExpanded: isExpanded
      });
      if (isExpanded) {
        this.reloadIframe();
      }
    }
  }, {
    key: "iframeOnLoadCallback",
    value: function iframeOnLoadCallback() {
      this.actions.setCustomWidgetStatus({
        id: this.widgetData.Id,
        statusId: CUSTOM_WIDGET_STATUSES.idle
      });
    }
  }, {
    key: "iframeOnFailCallback",
    value: function iframeOnFailCallback() {
      this.actions.setCustomWidgetStatus({
        id: this.widgetData.Id,
        statusId: CUSTOM_WIDGET_STATUSES.errored
      });
    }
  }, {
    key: "initCustomWidgetWithApiIntegration",
    value: function initCustomWidgetWithApiIntegration() {
      var _this3 = this;
      return CustomWidgetContainer.call(this, {
        actions: {
          boundCloneUserSession: {
            enumerable: false,
            value: this.actions.cloneUserSession
          },
          boundSetCustomWidgetStatus: {
            enumerable: false,
            value: this.actions.setCustomWidgetStatus
          }
        },
        container: angular.element("#".concat(WIDGET_ELEMENT_ID_PREFIX, "-").concat(this.widgetData.Id))[0],
        data: {
          businessUnit: {
            id: this.state.currentBusinessUnit.id,
            name: this.state.currentBusinessUnit.name,
            systemId: this.state.currentBusinessUnit.systemId
          },
          environment: this.state.environmentName,
          user: {
            id: this.state.currentUserContext.Id,
            roles: this.state.currentUserContext.Roles
          },
          widgetId: this.widgetData.Id
        },
        methods: {
          /**
           * Disconnect the container and widget.
           * @returns {void}
           */
          disconnect: function disconnect() {
            // Remove the iFrame element and destroy any `message` event listeners
            if (this.widget && this.widget.disconnect) {
              this.widget.disconnect();
            }
          },
          /**
           * Handle an encountered error.
           * @param {Error} error - Error encountered.
           *
           * @returns {Promise.<Error>} Promise object that _resolves_ to the provided error to support chaining.
           */
          handleError: function handleError(error) {
            var _this2 = this;
            return new Promise(function (resolve) {
              _this2.actions.setCustomWidgetStatus({
                id: _this2.widgetData.Id,
                statusId: CUSTOM_WIDGET_STATUSES.errored
              });
              resolve(error);
            });
          }
        },
        state: this.$state,
        url: "".concat(this.state.customWidgetHostedUrlBase, "/").concat(this.widgetData.Id, "/index.html")
      }).then(function (instance) {
        _this3.widget = instance;
        if (_this3.widget && _this3.widget.api && _this3.widget.api.log) {
          _this3.widget.api.log('Message sent from widget container using the example widget\'s custom `log` method...');
        }
        return Promise.resolve(instance);
      }).catch(function (error) {
        _this3.actions.setCustomWidgetStatus({
          id: _this3.widgetData.Id,
          statusId: CUSTOM_WIDGET_STATUSES.errored
        });
        return Promise.reject(error);
      });
    }
  }, {
    key: "reloadIframe",
    value: function reloadIframe() {
      var _this4 = this;
      var container = angular.element("#".concat(WIDGET_ELEMENT_ID_PREFIX, "-").concat(this.widgetData.Id))[0];
      if (container && container.hasChildNodes()) {
        while (container.firstChild) {
          container.removeChild(container.firstChild);
        }
      }
      this.actions.setCustomWidgetStatus({
        id: this.widgetData.Id,
        statusId: CUSTOM_WIDGET_STATUSES.processing
      });
      if (this.state.customWidgetHasApiIntegration) {
        this.$timeout(function () {
          _this4.initCustomWidgetWithApiIntegration();
        });
      }
    }
  }]);
}();
export default {
  template: require('./custom.widget.html'),
  bindings: {
    widgetData: '<'
  },
  controller: LandingPageCustomWidgetController,
  controllerAs: 'ctrl'
};